// Dialoge des Moduls smartview-kopf, die von mehreren Stellen geöffnet werden (Seitenleiste, Smart-View-Kopf, ⌘⇧L,
// Befehlspalette): Neuer Lead und Leads importieren. Gehostet werden sie einmal in der Navigation (immer sichtbar).
import { useEffect } from "react";
import type { NeuerLeadEingabe } from "../../api/leadsNeu";

const EREIGNIS = "crm:smartview-dialog";

export type DialogAuftrag = { art: "neu"; vorbelegung?: Partial<NeuerLeadEingabe> } | { art: "import" };

export function neuerLeadOeffnen(vorbelegung?: Partial<NeuerLeadEingabe>): void {
  window.dispatchEvent(new CustomEvent<DialogAuftrag>(EREIGNIS, { detail: { art: "neu", vorbelegung } }));
}

export function leadsImportierenOeffnen(): void {
  window.dispatchEvent(new CustomEvent<DialogAuftrag>(EREIGNIS, { detail: { art: "import" } }));
}

export function useDialogAuftrag(fn: (a: DialogAuftrag) => void): void {
  useEffect(() => {
    const h = (e: Event) => fn((e as CustomEvent<DialogAuftrag>).detail);
    window.addEventListener(EREIGNIS, h);
    return () => window.removeEventListener(EREIGNIS, h);
  }, [fn]);
}
